import { fetchHandler } from '../../util/fetchHandler';
import { IABTestRest } from './types';

const AB_AUTH_URL = '/rest/abtesting/auth';

export const loadTestsState = (): Promise<IABTestRest> => {
    return fetchHandler(AB_AUTH_URL);
};
